import { GET_AUDIO_USE, LISTAR_AUDIOS } from './mutation-types'

import AudiosHttpService from '../_services/AudiosHttpService'

export default {
  listarAudios: async ({ commit }) => {
    try {
      const response = await AudiosHttpService.getAudios()
      commit(LISTAR_AUDIOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarAudioUse: async ({ commit }, id) => {
    try {
      const response = await AudiosHttpService.getAudioUse(id)
      commit(GET_AUDIO_USE, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
